// logView records a 'view' audit-log entry server-side - only pass true when the
// UID data is actually being shown to the user (UidCheckModal), not for background
// status polling (e.g. the Documents page's status-badge sync).
export async function uidGetByClientId(clientId: string, logView = false) {
  const url = `${process.env.REACT_APP_API_URL}/uid/company/${clientId}${logView ? '?logView=true' : ''}`
  const response = await fetch(url, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })
  return response.json()
}

export async function uidGetByUid(uid: string, clientId: string, localSnapshot?: object) {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/uid/company/${clientId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ uid, localSnapshot }),
  })
  return response.json()
}

export async function uidAuditLogs(clientId: string) {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/uid/audit-logs/${clientId}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })
  return response.json()
}
